<div class="container-fluid form-div h-100">
  <div class="row justify-content-center">
    <div class="col-md-5 col-11">
      <img src="" class="logo mb-5" alt="" />
      <p class="text-gray h3 mb-4"><b>Reset</b> password</p>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <app-auth-input
          [inputData]="attributeConstant.email"
          [formControlName]="attributeConstant.email.key">
        </app-auth-input>
        <app-auth-input
          [inputData]="attributeConstant.new_password"
          [formControlName]="attributeConstant.new_password.key">
        </app-auth-input>
        <app-auth-input
          [inputData]="attributeConstant.confirm_password"
          [formControlName]="attributeConstant.confirm_password.key">
        </app-auth-input>
        <button class="btn primary-btn w-100">Submit</button>
      </form>
    </div>
  </div>
</div>
